import { hooks, site } from '@yola/ws-sdk';
import constants from '../constants';
import trackEvent from './track-event';
import getTemplateBuildSlugTrait from '../helpers/get-template-build-slug-trait';

const trackPageCreated = () => {
  hooks.operations.subscribe(hooks.availableHooks.ON_AFTER_ADD_NEW_PAGE, (pageId) => {
    trackEvent(constants.events.PAGE_CREATED_EVENT, {
      siteId: site.accessors.getSiteId(),
      templateBuildSlug: getTemplateBuildSlugTrait(),
      pageTemplate: site.accessors.getPageTemplateId(pageId) || null,
      pageCount: site.accessors.getPages().length,
    });
  });
};

export default trackPageCreated;
